import { Tooltip, message } from "antd";
import React, { useContext } from "react";
import { useSearchParams  } from "react-router-dom";
import MPriceWidget from "Components/mobile/activity/MPriceWidget";
import { AppContext } from "Store";
import defaultProductPic from "Images/default-brand.jpg";
import addToCartIcon from "Images/addToCart.svg";
import { getAuthToken, handleLogin } from "Utils/common";
import { getSelectedSTObj } from "Utils/addressUtils";
import axios from "axios";
import { cartAddUrl, USER_TYPE } from "Utils/constant";
import { addToCartErrorHandle, gotoPdp } from "Utils/activityHelper";
import { logOperation } from "Utils/operationLogUtils";
import { addToCartDataPush } from "Utils/analyticsUtils";
export interface ProductCardProps {
  product: {
    sku: number | string;
    productSize?: string;
    productName: string;
    pdpViewable?: boolean;
    productPic?: string;
    description?: string;
    listPrice?: number | string;
    priceStatus?: string;
    shoppingQty?: number;
    finalPrice?: number | string;
    level1Qty?: number;
    level1Price?: string;
    level2Qty?: number;
    level2Price?: number | string;
    priceType?: string;
    promoPrice?: number | string;
  };
  cartData?: Object;
  previewData?: Object;
  isOrderPreviewFlag?: true,
  loginState?: Object;
  tab?: string;
  activityId?: number | string;
  previewFlag?: boolean;
  contactUs?: () => void;
}
export type CounterRef = {
  addToCart: () => void;
  updateShoppingQty: (newQty: number) => void;
};

const MProductCard: React.FC<ProductCardProps> = (props: any) => {
  const [searchParams] = useSearchParams();
  const filter = searchParams.get('filter');
  const { checkedCartItems, setCheckedCartItems, setCartCount } =
    useContext(AppContext);
  const { product, loginState, tab, activityId, previewFlag } = props;
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const [processing, setProcessing] = React.useState(false);
  console.log("MProductCard filter", filter);
  return (
    <div className="productCardWrapper">
      <div className="productCard">
        <div className="imgWrapper">
          <img
            alt={product.productName}
            src={product.productPic || defaultProductPic}
            onClick={() => {
              const holder =
                tab === "activity" ? "Activity_Detail" : "Exchange_Detail";
                const isReturnBtn = true;
                console.log("going to pdp filter", filter);
                gotoPdp(product, loginState, holder, isReturnBtn, filter);
            }}
          ></img>
        </div>
        <div className="right">
          <div className="line line1">
            <span>{product.sku}</span>
            {product.productSize && (
              <>
                <span className="vdivider"></span>
                <span
                  dangerouslySetInnerHTML={{ __html: product.productSize }}
                ></span>
              </>
            )}
          </div>
          <Tooltip
            title={
              <div
                dangerouslySetInnerHTML={{ __html: product.productName }}
              ></div>
            }
            trigger={"hover"}
          >
            <div
              className={
                product.pdpViewable && !isEmployee ? "line line2 linkable" : "line line2"
              }
              style={{ color: isEmployee ? undefined : "#005daa" }}
              onClick={() => {
                console.log("product card clicked");
                const holder =
                  tab === "activity" ? "Activity_Detail" : "Exchange_Detail";
                const isReturnBtn = true;
                console.log("going to pdp filter", filter);
                gotoPdp(product, loginState, holder, isReturnBtn, filter);
              }}
              dangerouslySetInnerHTML={{ __html: product.productName }}
            ></div>
          </Tooltip>
          {product.description && (
            <Tooltip title={product.description} trigger={"hover"}>
              <div
                className="line line3"
                dangerouslySetInnerHTML={{ __html: product.description }}
              ></div>
            </Tooltip>
          )}
          <div className="line line5">
            <MPriceWidget product={product} loginState={loginState} />
            <div>
              {loginState.status === "login" ? (
                <span
                  onClick={(e) => {
                    console.log("add to cart");
                    if (!product.available) return;
                    if (processing) return;
                    setProcessing(true);
                    e.stopPropagation();
                    if (previewFlag) {
                      message.error(
                        "活动预热期间，该产品暂时无法加入购物车",
                        undefined,
                        () => {
                          setProcessing(false);
                        }
                      );
                      return;
                    }
                    if (product.priceStatus === "ContactUs") {
                      message.error(
                        "该产品不支持网络订购，如有需要，请联系我们",
                        undefined,
                        () => {
                          setProcessing(false);
                        }
                      );
                      return;
                    }
                    const selectedST = getSelectedSTObj(loginState);
                    axios(cartAddUrl, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: getAuthToken(),
                      },
                      data: {
                        activityId: activityId,
                        type: tab,
                        category: product.category,
                        sku: product.sku,
                        quantity: 1,
                        customerStNumber: selectedST?.accountNumber,
                      },
                    })
                      .then((resp) => {
                        console.log("add to cart", resp);
                        const respData = resp.data;
                        if (respData?.status === "success") {
                          message.success("已加入购物车");
                          const ids: number[] = respData?.data?.cartIds;
                          const count = respData?.data?.cartCount || 0;
                          ids && checkedCartItems.add(ids[0]);
                          setCheckedCartItems(new Set(checkedCartItems));
                          setCartCount(count);
                          setProcessing(false);
                          const cartObj = {
                            cartId: activityId
                          };
                          addToCartDataPush({
                            cartObj,
                            placement: "marketing",
                            method: "product_card",
                            products: [{
                              name: product?.productName,
                              catalogId: product.catalogNumber,
                              quantity: 1,
                              price: product.finalPrice ? (product.finalPrice * 1).toFixed(2) : "0",
                            }]
                          })
                          return;
                        }
                        addToCartErrorHandle(respData, message, 'common', 'mobile');
                        setProcessing(false);
                      })
                      .catch((err) => {
                        console.log("add to cart error", err);
                        setProcessing(false);
                        message.error(
                          "加入购物车失败, 可能是该产品不支持在线下单，如果问题持续，请联系客服"
                        );
                      });
                    logOperation({
                      opUser: loginState?.user?.user?.userId,
                      opTarget: "Add_To_Cart",
                      opTargetId: product.sku,
                      opContent:
                        tab === "activity"
                          ? "Activity_Detail"
                          : "Exchange_Detail",
                    });
                  }}
                >
                  {product.available ? (
                    <img src={addToCartIcon} alt="addToCart"></img>
                  ) : (
                    <span
                      style={{
                        border: "1px solid #d9d9d9",
                        borderRadius: "4px",
                        padding: "3px 5px",
                        fontSize: "13px",
                        backgroundColor: "#0000000a",
                        color: "#00000040",
                        whiteSpace: 'nowrap'
                      }}
                    >
                      已售罄
                    </span>
                  )}
                </span>
              ) : (
                <span onClick={handleLogin}>
                  <img src={addToCartIcon} alt="addToCart"></img>
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MProductCard;
